export function useSearchResult(
  ss: SearchStore<Item>,
  test: boolean,
) {
  const { $getSortOptions } = useNuxtApp()
  const { getItemNoImage } = useNoImage()

  const leftFacetFields = computed(() => {
    return (
      ss?.state.searchdef?.searchFields?.filter(
        sf =>
          sf.hasFacet &&
          [
            'database',
            'contents',
            'organization',
            'provider',
            'code',
            'keyword',
            'prefectures',
            'temporal',
            'temporal_group',
          ].includes(sf.type),
      ) || []
    )
  })

  const leftFacets = computed(() => {
    return leftFacetFields.value
      .map(ff => {
        return ('hasSideBarFacet' in ff ? ff.hasSideBarFacet : true) && ss.state.result.facets.filter(f => f.key === ff.key).pop()
      })
      .filter(d => d != null)
  })

  const getLeftFacetShowCount = (key: string) => {
    const count = leftFacetFields.value.find(ff => ff.key === key)?.sideBarFacetShowCount || -1
    return count === -1 ? undefined : count
  }

  const sortOptions = (): SortOption[] => {
    return $getSortOptions()
  }

  const imageSearchEnabled = computed(() => {
    return (
      ss?.state.searchdef?.searchFields?.some(sf => sf.type === 'image') ||
      ss?.state.searchdef?.keywordFields?.includes('text2image')
    )
  })

  const imageSearchTo = (i: Item) => {
    return `/csearch/${ss.state.searchdef.id}?csid=${ss.state.searchdef.id}&image=${i.id}&from=0`
  }

  const list = val => {
    return listToJoinString(val)
  }

  const itemTo = (i: Item, isWebParts: boolean = false) => {
    if (isWebParts) return null
    if (test) {
      return `/item/test/${i.id}`
    } else {
      return `/item/${i.id}`
    }
  }

  const ownerTo = (i: Item) => {
    return `/organization/${i.common.ownerOrg}`
  }

  const dbTo = (i: Item) => {
    return `/database/${i.common.database}`
  }

  const getNoImage = (i: Item) => {
    return getItemNoImage(i)
  }

  return {
    leftFacetFields,
    leftFacets,
    getLeftFacetShowCount,
    sortOptions,
    imageSearchEnabled,
    imageSearchTo,
    list,
    itemTo,
    ownerTo,
    dbTo,
    getNoImage,
  }
}
